<template lang='pug'>
.articleNoThumbnail-item
  //- top section of articleNoThumbnail
  .articleNoThumbnail-top(@click="goTo")
    v-clamp.articleNoThumbnail-text(autoresize :max-lines="2") {{ info.content }}
  //- middle section of articleNoThumbnail
  .articleNoThumbnail-middle
    .articleNoThumbnail-time
      .color--greyBlue90 {{ time }}
    .articleNoThumbnail-report
      i.icon-report2.articleNoThumbnail-icon
      .color--greyBlue90 {{ getNumberString(info.reporterCount) }}
    .articleNoThumbnail-follow
      //- will show the blue version of the eye icon when isFollowing is true
      i.articleNoThumbnail-icon(:class="followed ? 'icon-follow-blue' : 'icon-follow'" )
      //- will change text color to blue when isFollowing is true
      div(:class="followed ? 'color--blueCornFlower' : 'color--greyBlue90'") {{ getNumberString(followerCount) }}


  //- bottom section of articleNoThumbnail
  .articleNoThumbnail-bottom
    .articleNoThumbnail-tag(:class="getTagClass(info.tag.id, 'articleNoThumbnail-tag')") {{ info.tag[$store.state.lang] }}
    .articleNoThumbnail-info(v-if="info.tag.id !== 1 && info.comments.length > 0")
      span.articleCard-info-partner {{ info.comments[0].partner.name}}
      span(v-if="info.comments.length > 1") ...
        span {{ "(" + info.comments.length + ")" }}

    //- button
    .articleNoThumbnail-button(v-if="followed" @click="unfollowArticle(info.id)" class='articleNoThumbnail-button--outlined')
      .articleNoThumbnail-iconButton.icon-following
      .articleNoThumbnail-textButton {{ staticData.isfollowBtnText }}
    .articleNoThumbnail-button(v-else @click="followArticle(info.id)" class='articleNoThumbnail-button--blue')
      .articleNoThumbnail-textButton {{ staticData.unfollowBtnText }}
</template>
<script>
import { getTime, getTagClass, getNumberString } from '@/plugins/tool.js'
import { login } from "@/plugins/login.js"
import { followArticle } from '@/plugins/api.js'
import VClamp from 'vue-clamp'
export default {
  components: {
    VClamp
  },
  props: {
    info: Object,
    idx: Number,
    staticData: Object,
    token: String
  },
  data() {
    return {
      tagClass: "",
      localFollowStatus: null,
      getNumberString: getNumberString,
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  computed: {
    time() {
      return getTime(this.info.updatedAt)
    },
    followed() {
      return this.localFollowStatus != null ? this.localFollowStatus : this.info.followStatus
    },
    followerCount() {
      if (this.info.followStatus == true) {
        if (this.localFollowStatus == false)
          return this.info.followerCount - 1
      }
      else if (this.info.followStatus == false) {
        if (this.localFollowStatus == true)
          return this.info.followerCount + 1
      }
      return this.info.followerCount
    }
  },
  methods: {
    async followArticle(id) {
      if (this.token == null)
        login(this.$store.state)
      else {
        this.localFollowStatus = !this.followed
        followArticle("follow", this.$store.state, this.$axios, id)
      }
    },
    async unfollowArticle(id) {
      this.localFollowStatus = !this.followed
      followArticle("unfollow", this.$store.state, this.$axios, id)
    },
    goTo() {
      this.$router.push({
        "path": "/news",
        "query": {
          "categoryId": this.info.category.id,
          "articleId": this.info.id
        }
      })
    },
    getTagClass(tagId, className) {
      return getTagClass(tagId, className)
    }
  }
}
</script>
